{
  "cash": {
    "totalBalance": 100000000.00,
    "reservedBalance": 0.00,
    "availableBalance": 100000000.00,
    "currency": "EUR"
  },
  "totalBalance": 100000000.00,
  "reservedBalance": 0.00,
  "availableBalance": 100000000.00,
  "currency": "EUR"
}
